export default __webpack_public_path__ + "b92e0ef.png";